import React, { useEffect } from 'react'

import { useHistory, useLocation, Link } from 'react-router-dom'
// import LogoutIcon from '../../assests/images/logout.svg'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// import Logo from '../../assests/images/logo-dark.png';
// import UserProfile from '../../assests/images/faces/face1.jpg';
import { S3_BUCKET_URL } from '../../config/HttpService'
const Header = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const code = queryParams.get('code')
    if (code) {
      history.push({
        pathname: '/dropboximagesync',
        search: `code=${code}`
      })
    }
  }, [])

  // remove user from local storage to log user out
  const logout = (e) => {
    e.preventDefault()
    localStorage.removeItem('appState')
    localStorage.removeItem('PermissionList')
    window.location.href = '/login'
  }

  return (
    <>
      <header>
        <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
          <div className="navbar-menu-wrapper d-flex align-items-stretch">
            <button
              className="navbar-toggler navbar-toggler align-self-center"
              type="button"
              data-toggle="minimize"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#c394a8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-chevron-left"
              >
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
              <Link
                className="navbar-brand brand-logo-mini"
                to="/"
              >
                <img
                  src={S3_BUCKET_URL + 'assests/images/logo-dark.png'}
                  width="79px"
                  alt="logo"
                />
              </Link>
            </div>
            <ul className="navbar-nav navbar-nav-right">
              <li
                className="nav-item nav-logout d-none d-lg-block"
                title="Analytics"
              >
                <Link
                  className="nav-link"
                  to="/analytics"
                >
                  <i
                    className="fa fa-line-chart"
                    aria-hidden="true"
                  ></i>
                </Link>
              </li>
              <li
                className="nav-item nav-logout d-none d-lg-block"
                title="Logout"
              >
                <Link
                  className="nav-link"
                  to=""
                  onClick={logout}
                >
                  <img
                    src={S3_BUCKET_URL + 'assets/images/logout.svg'}
                    alt="logout"
                  />
                </Link>
              </li>
            </ul>
            <button
              className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
              type="button"
              data-toggle="offcanvas"
            >
              <span className="mdi mdi-menu"></span>
            </button>
          </div>
        </nav>
        <ToastContainer />
      </header>
    </>
  )
}

export default Header
